
import * as XLSX from 'xlsx-js-style';

export async function generateFicheCommande(commande) {
    const response = await fetch("/assets/excel/Fiche_Commande.xlsx");
    const arrayBuffer = await response.arrayBuffer();

    const workbook = XLSX.read(arrayBuffer, { type: 'array' });
    const sheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[sheetName];
    worksheet['!cols'] = [{ wch: 3 }, { wch: 10 }, ...Array.from({ length: 10 }, () => ({ wch: 4 }))];
    worksheet['!rows'] = [...Array.from({ length: 20 }, () => ({ hpt: 28 }))];

    worksheet["C2"] = { t: "s", v: commande.identite.prenom + " " + commande.identite.nom };
    worksheet["C3"] = { t: "s", v: commande.identite.adresse.rue + "," + commande.identite.adresse.numero };
    worksheet["C4"] = { t: "s", v: commande.identite.adresse.codePostal };
    worksheet["H4"] = { t: "s", v: commande.identite.adresse.localite };
    worksheet["C5"] = { t: "s", v: commande.identite.coordonnee.filter(c => c.typeCoordonnee === "GSM" || c.typeCoordonnee === "FIXE").map(c => c.information).join(", ") };
    worksheet["C6"] = { t: "s", v: commande.identite.coordonnee.find(c => c.typeCoordonnee === "EMAIL")?.information || "" };

    worksheet["C8"] = { t: "s", v: commande.quantiteBois };
    worksheet["F8"] = { t: "s", v: commande.prixUnitaireBois };
    worksheet["C9"] = { t: "s", v: (commande.quantiteBois * parseFloat(commande.prixUnitaireBois)).toFixed(2) };

    worksheet["C10"] = { t: "s", v: commande.quantiteSac };
    worksheet["F10"] = { t: "s", v: commande.prixUnitaireSac };
    worksheet["C11"] = { t: "s", v: (commande.quantiteSac * parseFloat(commande.prixUnitaireSac)).toFixed(2) };

    worksheet["C7"] = { t: 's', v: commande.longueurBois || "" };

    worksheet["I10"] = { t: "s", v: commande.fraisLivraison.distance };
    worksheet["I11"] = { t: "s", v: commande.fraisLivraison.prix };

    worksheet["C12"] = { t: "s", v: commande.reduction };
    worksheet["C13"] = { t: "s", v: (commande.quantiteBois * parseFloat(commande.prixUnitaireBois) + (commande.quantiteSac * parseFloat(commande.prixUnitaireSac)) + parseFloat(commande.fraisLivraison.prix) - parseFloat(commande.reduction)).toFixed(2) };

    worksheet["I13"] = { t: "s", v: commande.numFacture || "" };
    worksheet["C14"] = { t: "s", v: commande.notes || "" };

    worksheet["C16"] = { t: "d", v: new Date(commande.dateCreation) || "" };

    worksheet["C17"] = { t: 's', v: commande.trancheHoraire || "" };

    worksheet["J17"] = { t: 's', v: commande.typePaiement || "" };


    //Titre en gris
    ["B1", "B2", "B3", "B4", "B5", "B6", "B7", "B8", "B9", "B10", "B11", "B12", "B13", "B14", "B15", "B16", "B17",
        "E8", "E10", "F4", "F5", "G7", "H8", "H9", "H10", "H11", "H12", "H13", "G16", "G17", "I9", "I12", "J1", "L11"].forEach(cellRef => {
            const cell = worksheet[cellRef];
            if (cell) {
                cell.s = {
                    fill: {
                        fgColor: { rgb: "D3D3D3" }
                    },
                    font: {
                        bold: true
                    },
                    alignment: {
                        horizontal: "center",
                        vertical: "center",
                        wrapText: true
                    }
                }
            }
        });
    //allignement des cellule
    const styleAllCells = {
        alignment: {
            horizontal: "center",
            vertical: "center",
            wrapText: true
        },
    };

    for (let row = 1; row <= 17; row++) {
        for (let colCode = 'B'.charCodeAt(0); colCode <= 'L'.charCodeAt(0); colCode++) {
            const colLetter = String.fromCharCode(colCode);
            const cellRef = `${colLetter}${row}`;
            const cell = worksheet[cellRef];
            if (cell) {
                if (!cell.s) cell.s = {};
                cell.s = {
                    ...cell.s,
                    ...styleAllCells
                };
            }
        }
    }


    //cellule avec contour
    const cellStyle = {
        border: {
            top: { style: "thin", color: { rgb: "000000" } },
            right: { style: "thin", color: { rgb: "000000" } },
            bottom: { style: "thin", color: { rgb: "000000" } },
            left: { style: "thin", color: { rgb: "000000" } }
        }
    };

    for (let row = 1; row <= 17; row++) {
        for (let colCode = 'B'.charCodeAt(0); colCode <= 'L'.charCodeAt(0); colCode++) {
            const colLetter = String.fromCharCode(colCode);
            const cellRef = `${colLetter}${row}`;

            // Création de la cellule si elle n'existe pas
            if (!worksheet[cellRef]) {
                worksheet[cellRef] = { t: 's', v: '' };
            }

            // Application du style
            worksheet[cellRef].s = {
                ...worksheet[cellRef].s,
                ...cellStyle
            };
        }
    }

    workbook.Sheets[sheetName] = worksheet;

    const wbout = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const blob = new Blob([wbout], { type: "application/octet-stream" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `Commande_${commande.identite.prenom + "_" + commande.identite.nom}.xlsx`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);

   // Conversion de la feuille en HTML
const html = XLSX.utils.sheet_to_html(worksheet);

// Ouvrir une nouvelle fenêtre et injecter le contenu
const printWindow = window.open("", "_blank");
printWindow.document.write(`
  <html>
    <head>
      <title>Impression Commande</title>
      <style>
        body { font-family: Arial, sans-serif; padding: 10px; }
        table { border-collapse: collapse; width: 100%; }
        td, th { border: 1px solid #000; padding: 4px; text-align: left; }
      </style>
    </head>
    <body>
      ${html}
      <script>
        window.onload = function() {
          window.print();
          window.onafterprint = window.close;
        }
      </script>
    </body>
  </html>
`);
printWindow.document.close();

}
